import React, { useState, useEffect, useCallback } from 'react'
import { Modal, Form, Input, Space, Radio, Steps, App, Select, InputNumber   } from 'antd'
import { useFYspjdUpdateQuery, useFYspjdAddMutation } from '../../../store/DianShangYeWuApi'
import Icon from '../../../cpn/Icon'
function RuleExpenseCopy(props) {    
    const useList = props.useList.map(item => ({value:item.yh_id,label:item.yh_name,key:item.yh_id}));
    const deptList = props.deptList.map(item => ({value:item.d_id,label:item.d_name,key:item.d_id}));
    const [form] = Form.useForm();
    const {message} = App.useApp();
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState({
        fy_spjd_content: '',
        fy_spjd_bm_id: '',
        fy_spjd_bm_name: '',
        fy_spjd_user_id: '',
        fy_spjd_user_name: '',
        fy_spjd_zflx: '',
        fy_spjd_amount_min: '',
        fy_spjd_amount_max: '',
    });
    const {data, isSuccess} = useFYspjdUpdateQuery({fy_spjd_id:props.fy_spjd_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){
            setInfo(data.Result);
            form.setFieldsValue({
                fy_spjd_content: data.Result.fy_spjd_content,
                fy_spjd_bm_id: data.Result.fy_spjd_bm_id,
                fy_spjd_bm_name: data.Result.fy_spjd_bm_name,
                fy_spjd_user_id: data.Result.fy_spjd_user_id,
                fy_spjd_user_name: data.Result.fy_spjd_user_name,
                fy_spjd_zflx: data.Result.fy_spjd_zflx,
                fy_spjd_amount_min: data.Result.fy_spjd_amount_min,
                fy_spjd_amount_max: data.Result.fy_spjd_amount_max,
            });
            
            // 解析审批点数据并设置为默认值
            if(data.Result.fy_spjd_name && data.Result.fy_spjd_yh_id && data.Result.fy_spjd_yh_name){
                const names = data.Result.fy_spjd_name.split(',');
                const userIds = data.Result.fy_spjd_yh_id.split(',');
                const userNames = data.Result.fy_spjd_yh_name.split(',');
                
                const nodes = names.map((name, index) => ({
                    title: name + '：' + (userNames[index] || ''),
                    content: '',
                    status: 'wait',
                    fy_spjd_name: name,
                    fy_spjd_yh_id: userIds[index] || '',
                    fy_spjd_yh_name: userNames[index] || '',
                }));
                
                setNewNode(nodes);
            }
        }
    }, [data, isSuccess, form])
    const [newNode, setNewNode] = useState([]);
    const [items, setItems] = useState([]);
    const [submitAdd] = useFYspjdAddMutation();
    const [editNodeModalOpen, setEditNodeModalOpen] = useState(false);
    const [editingNodeIndex, setEditingNodeIndex] = useState(-1);
    const [editNodeForm] = Form.useForm();
    const [editNodeInfo, setEditNodeInfo] = useState({
        node_type: '',
        node_user_id: '',
        node_user_name: '',
    }); 
    const handleEditNode = useCallback((index) => {
        const node = newNode[index];
        setEditingNodeIndex(index);
        const nodeInfo = {
            node_type: node.fy_spjd_name,
            node_user_id: node.fy_spjd_yh_id,
            node_user_name: node.fy_spjd_yh_name,
        };
        setEditNodeInfo(nodeInfo);
        setEditNodeModalOpen(true);
        // 延迟设置表单值，确保 Modal 已经打开
        setTimeout(() => {
            editNodeForm.setFieldsValue({
                node_type: node.fy_spjd_name,
                node_user_id: node.fy_spjd_yh_id,
            });
        }, 100);
    }, [newNode, editNodeForm]);
    
    const handleDeleteNode = useCallback((index) => {
        setNewNode(prev => prev.filter((_, i) => i !== index));
    }, []);
    
    useEffect(() => {
        setItems(
            newNode.map((node, index) => ({
                ...node,
                subTitle: (
                    <Space>
                        <a onClick={() => handleEditNode(index)}>修改</a>
                        <a onClick={() => handleDeleteNode(index)} style={{color: 'red'}}>删除</a>
                    </Space>
                )
            }))
        );
    }, [newNode, handleEditNode, handleDeleteNode]);
    
    const handleSaveEditNode = () => {
        if(!editNodeInfo.node_type){
            message.error('请选择节点类型');
            return;
        }
        if(!editNodeInfo.node_user_name){
            message.error('请选择操作员');
            return;
        }
        
        setNewNode(prev => prev.map((node, index) => 
            index === editingNodeIndex 
                ? {
                    title: editNodeInfo.node_type + '：' + editNodeInfo.node_user_name,
                    content: '',
                    status: 'wait',
                    fy_spjd_name: editNodeInfo.node_type,
                    fy_spjd_yh_id: editNodeInfo.node_user_id,
                    fy_spjd_yh_name: editNodeInfo.node_user_name,
                }
                : node
        ));
        setEditNodeModalOpen(false);
        setEditingNodeIndex(-1);
        editNodeForm.resetFields();
        setEditNodeInfo({
            node_type: '',
            node_user_id: '',
            node_user_name: '',
        });
    };
    const onAdd = () => {
        if(!info.fy_spjd_content){
            message.error('请输入规则名称');
            return;
        }
        if(!info.fy_spjd_bm_id){
            message.error('请选择部门');
            return;
        }
        if(!info.fy_spjd_zflx){
            message.error('请选择往来类型');
            return;
        }
        if(!info.fy_spjd_amount_min){
            message.error('请输入最小金额');
            return;
        }
        if(!info.fy_spjd_amount_max){
            message.error('请输入最大金额');
            return;
        }
        let obj ={
            'fy_spjd_qy_id': props.qy_id,
            'fy_spjd_qy_name': props.qy_name,
            'fy_spjd_xuhao': '',
            'fy_spjd_name': '',
            'fy_spjd_yh_id': '',
            'fy_spjd_yh_name': '',
            'fy_spjd_uid': props.yh_id,
            'fy_spjd_uname': props.yh_name,
            'fy_spjd_content': info.fy_spjd_content,
            'fy_spjd_user_id': info.fy_spjd_user_id,
            'fy_spjd_user_name': info.fy_spjd_user_name,
            'fy_spjd_bm_id': info.fy_spjd_bm_id,
            'fy_spjd_bm_name': info.fy_spjd_bm_name,
            'fy_spjd_zflx': info.fy_spjd_zflx,
            'fy_spjd_amount_min': info.fy_spjd_amount_min,
            'fy_spjd_amount_max': info.fy_spjd_amount_max,
        }
        
        // 2. 校验 items 节点
        if (!items || items.length === 0 || (items.length === 1 && !items[0].fy_spjd_yh_id)) {
            message.error("请设置至少一个审批/抄送节点");
            return;
        }
        // 3. 过滤掉无效节点
        const validItems = items.filter(item => !!item.fy_spjd_yh_id && !!item.fy_spjd_yh_name);

        // 4. 填充 obj 字段
        // 不需要前面1,2两个元素了，直接从items的第一个开始
        // 填充序号
        let s = validItems.length;
        let xuhaoArr = [];
        for(let i=1; i<=s; ++i) xuhaoArr.push(i);
        obj.fy_spjd_xuhao = xuhaoArr.join(',');

        // 填充fy_spjd_name
        obj.fy_spjd_name = validItems.map(item => item.fy_spjd_name).join(',');

        // 填充fy_spjd_yh_id
        obj.fy_spjd_yh_id = validItems.map(item => item.fy_spjd_yh_id).join(',');

        // 填充fy_spjd_yh_name
        obj.fy_spjd_yh_name = validItems.map(item => item.fy_spjd_yh_name).join(',');

       

        // 5. 提交
        submitAdd(obj).then(res => {
            if (res && res.data && res.data.Status === 'success') {
                message.success('新增成功');
                setOpen(false);
                setNewNode([]);
                setItems([]);
                setInfo({...info, 'fy_spjd_user_id':'', 'fy_spjd_user_name':''});
                props.onSuccess && props.onSuccess();
            } else {
                message.error('新增失败：' + (res?.data?.Message || '未知错误'));
            }
        });
    }
   
    return (
        <>
            <Icon type='copy' onClick={() => {setOpen(true)}} title='复制新增' />
            <Modal
                title='复制新增'
                open={open}
                onCancel={() => {
                    setOpen(false);
                    setNewNode([]);
                    setItems([]);
                }}
                width={800}
                footer={null}
                destroyOnHidden={false}
                forceRender
            >
                <Form form={form} layout='horizontal' labelCol={{ span: 6 }} name={`ruleExpenseEditForm_${props.fy_spjd_id}`}>
                    <Form.Item label='费用单规则名称' name='fy_spjd_content' rules={[{ required: true, message: '请输入规则名称' }]}>
                        <Input onChange={(e) => {setInfo(prev=>({...prev, 'fy_spjd_content': e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item label='费用单部门' name='fy_spjd_bm_id' wrapperCol={{ span: 10 }} required>    
                        <Select options={deptList} onChange={(e,f) => {setInfo(prev=>({...prev, 'fy_spjd_bm_id':e, 'fy_spjd_bm_name':f.label}))}} />
                    </Form.Item>
                    <Form.Item label='费用单往来类型' name='fy_spjd_zflx' wrapperCol={{ span: 10 }} required >
                        <Radio.Group options={[
                            {value: '现付', label: '现付'},
                                {value: '应付', label: '应付'},
                            ]} onChange={(e,f) => {setInfo(prev=>({...prev, 'fy_spjd_zflx':e.target.value}))}} >
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label='费用单最小金额' name='fy_spjd_amount_min' wrapperCol={{ span: 10 }} required >
                         <InputNumber min={0.01} precision={2} max={99999999.99} onChange={(value) => {setInfo(prev=>({...prev, 'fy_spjd_amount_min': value}))}} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label='费用单最大金额' name='fy_spjd_amount_max' wrapperCol={{ span: 10 }} required >
                        <InputNumber min={0.01} precision={2} max={99999999.99} onChange={(value) => {setInfo(prev=>({...prev, 'fy_spjd_amount_max': value}))}} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label="审批点" required wrapperCol={{ span: 18 }}>
                        <Space size={10}>
                            <Form.Item  name="node_type" noStyle>
                                <Radio.Group
                                    onChange={(e) => {
                                        setInfo(prev=>({...prev, node_type: e.target.value}))
                                    }}
                                >
                                    <Radio value="审批">审批</Radio>
                                    <Radio value="抄送">抄送</Radio>
                                </Radio.Group>
                            </Form.Item>                           
                            <Form.Item name="node_user_id" noStyle>
                                <Select 
                                    options={useList} 
                                    onChange={(value, option) => {
                                        setInfo(prev => ({
                                            ...prev, 
                                            'node_user_id': value, 
                                            'node_user_name': option ? option.label : ''
                                        }));
                                    }} 
                                    style={{ width: '200px' }}
                                    placeholder={info.node_type === '审批' ? '请选择审批人' : '请选择抄送人'}
                                    disabled={info.node_type === ''}
                                />
                            </Form.Item>
                            <Icon 
                                type='add' 
                                onClick={() => {
                                if(!info.node_type){
                                    message.error('请选择节点类型')
                                    return;
                                }
                                if(!info.node_user_name){
                                    message.error('请选择操作员')
                                    return;
                                }
                                setNewNode(prev => [...prev, {
                                    title: info.node_type + '：' + info.node_user_name,
                                    content: '',
                                    status: 'wait',
                                    fy_spjd_name: info.node_type,
                                    fy_spjd_yh_id: info.node_user_id,
                                    fy_spjd_yh_name: info.node_user_name,
                                }]);
                                form.resetFields(['node_type', 'node_user_id', 'node_content']);
                                setInfo(prev => ({
                                    ...prev,
                                    node_type: '',
                                    node_user_name: '',
                                    node_content: '',
                                    node_user_id: '',
                                }));
                                }} title='添加审批节点' 
                            />
                        </Space>
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 18,offset: 6 }}>
                        {items.length===0 && ''}
                        <div>
                            <style>
                                {`
                                    .ant-steps-item-title {
                                        color: #000 !important;
                                    }
                                `}
                            </style>
                            <Steps
                                items={items}
                                orientation="vertical"  
                                size="small"
                                current={items.length-1}
                            />
                        </div>
                    </Form.Item>  
                    <Form.Item wrapperCol={{ span: 18,offset:6}}>
                      <Space size={30}>
                      <Icon type='save' onClick={onAdd} title='保存' />
                    
                      </Space>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title='修改审批点'
                open={editNodeModalOpen}
                onOk={handleSaveEditNode}
                onCancel={() => {
                    setEditNodeModalOpen(false);
                    setEditingNodeIndex(-1);
                    editNodeForm.resetFields();
                    setEditNodeInfo({
                        node_type: '',
                        node_user_id: '',
                        node_user_name: '',
                    });
                }}
                width={500}
            >
                <Form form={editNodeForm} layout='vertical' name={`ruleExpenseCopyNodeForm_${props.fy_spjd_id}`}>
                    <Form.Item label='节点类型' name='node_type' rules={[{ required: true, message: '请选择节点类型' }]}>
                        <Radio.Group
                            value={editNodeInfo.node_type}
                            onChange={(e) => {
                                setEditNodeInfo(prev => ({...prev, node_type: e.target.value}));
                            }}
                        >
                            <Radio value="审批">审批</Radio>
                            <Radio value="抄送">抄送</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label='操作员' name='node_user_id' rules={[{ required: true, message: '请选择操作员' }]}>
                        <Select 
                            options={useList} 
                            value={editNodeInfo.node_user_id}
                            onChange={(value, option) => {
                                setEditNodeInfo(prev => ({
                                    ...prev, 
                                    'node_user_id': value, 
                                    'node_user_name': option ? option.label : ''
                                }));
                            }} 
                            placeholder={editNodeInfo.node_type === '审批' ? '请选择审批人' : '请选择抄送人'}
                            disabled={!editNodeInfo.node_type}
                        />                        
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default RuleExpenseCopy
